export default __webpack_public_path__ + "static/media/printflyone-brand-logo.6ffccfc1.png";